import imagesloaded from 'imagesloaded';
import Turbolinks from 'turbolinks';

import PhoneWithCountryCode from '@/views/phone_with_country_code';
import Switcher from '@/views/switcher';
import { buildMap } from '@/views/map';

import { toLandingLeadForm } from '@/articles/v4/landing_lead_form';

import onIntersectionObserve from '@/helpers/on_intersection_observe';
import track from '@/helpers/track';
import { isMobile } from '@/helpers/mobile_detect';

const IMAGE_ACTIVE = '/assets/static/b-map/marker-opened.svg';

let map = null;
let storageApp = null;

pageUnload('storages_show', () => {
  if (map) {
    map.destroy();
    map = null;
  }
  if (storageApp) {
    storageApp.unmount();
    storageApp = null;
  }
});

pageLoad('storages_show', async () => {
  if (!document.querySelector('.storages-v4-show')) { return; }

  const $storagePhoto = $('.slide_1 .photos .photo');
  if ($storagePhoto.length) {
    imagesloaded($storagePhoto.toArray(), () => initPhotos($storagePhoto));
  }

  const $node = $('#storage_app');
  renderStorageApp($node).then(app => storageApp = app);

  buildStorageMap();
  track({ event: 'view_storage' });
});

export function buildStorageMap() {
  onIntersectionObserve(
    document.querySelector('.b-map'),
    async mapNode => {
      map = (await buildMap({
        node: mapNode,
        leadProps: $(mapNode).data('lead-props'),
        isAutoCenter: false,
        isAutoOpen: true
      })).map;
    }
  );
}

export function initPhotos($photos) {
  $photos.magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1]
    }
  });
}

async function renderStorageApp($node) {
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: App } = await import('@/vue/storage_schema_boxes/index');

  const app = createApp(App, {
    isSoon: $node.data('is_soon'),
    boxes: $node.data('boxes'),
    fabricBoxes: $node.data('fabric_boxes'),
    levels: $node.data('levels'),
    guideSizes: $node.data('guide_sizes'),
    leadType: $node.data('lead_type'),
    leadSubmitUrl: $node.data('lead_submit_url'),
    graphqlUrl: $node.data('graphql_url'),
    privacyUrl: $node.data('privacy_url'),
    privacyConsentUrl: $node.data('privacy_consent_url'),
    xlCapacity: Number($node.data('xl_capacity'))
  });
  app.mount($node[0]);

  return app;
}
